import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Controls from './Controls';
import { useTheme } from '@emotion/react';

export default function DialogConfirm(props) {

    const { open, textTitle, textContent, handleClose, handleConfirm } = props;

    const theme = useTheme();

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            sx={{
                '& .MuiDialogTitle-root': {
                    fontSize: '1.5rem'
                },
                '& .MuiDialogContentText-root': {
                    fontSize: '1rem',
                    color: 'black'
                }
            }}
        >
            <DialogTitle
                >
                {textTitle}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {textContent}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Controls.ButtonKml
                    sx={{
                        color: theme.palette.background.default
                    }}
                    variant="contained"
                    text="SIM"
                    onClick={handleConfirm}
                />
                <Controls.ButtonKml
                    onClick={handleClose}
                    variant="outlined"
                    text="NÃO"
                />
            </DialogActions>
        </Dialog>
    )
}
